var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99992 12.6667C3.99992 13.4 4.59992 14 5.33325 14H10.6666C11.3999 14 11.9999 13.4 11.9999 12.6667V6C11.9999 5.26667 11.3999 4.66667 10.6666 4.66667H5.33325C4.59992 4.66667 3.99992 5.26667 3.99992 6V12.6667ZM11.9999 2.66667H10.3333L9.85992 2.19333C9.73992 2.07333 9.56659 2 9.39325 2H6.60659C6.43325 2 6.25992 2.07333 6.13992 2.19333L5.66659 2.66667H3.99992C3.63325 2.66667 3.33325 2.96667 3.33325 3.33333C3.33325 3.7 3.63325 4 3.99992 4H11.9999C12.3666 4 12.6666 3.7 12.6666 3.33333C12.6666 2.96667 12.3666 2.66667 11.9999 2.66667Z",
    fill: "#DC5D5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99992 12.6667C3.99992 13.4 4.59992 14 5.33325 14H10.6666C11.3999 14 11.9999 13.4 11.9999 12.6667V6C11.9999 5.26667 11.3999 4.66667 10.6666 4.66667H5.33325C4.59992 4.66667 3.99992 5.26667 3.99992 6V12.6667ZM11.9999 2.66667H10.3333L9.85992 2.19333C9.73992 2.07333 9.56659 2 9.39325 2H6.60659C6.43325 2 6.25992 2.07333 6.13992 2.19333L5.66659 2.66667H3.99992C3.63325 2.66667 3.33325 2.96667 3.33325 3.33333C3.33325 3.7 3.63325 4 3.99992 4H11.9999C12.3666 4 12.6666 3.7 12.6666 3.33333C12.6666 2.96667 12.3666 2.66667 11.9999 2.66667Z",
    fill: "url(#paint0_linear_127_13105)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_127_13105",
    x1: 7.99992,
    y1: 2,
    x2: 7.99992,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2B2C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.b5a49c2647cc61c33386d14ca9566fbc.svg";
export { ForwardRef as ReactComponent };